import { CheckboxInput, Grid } from '@kirz/mui-admin';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import React from 'react';

import { FilesField } from '../FilesField';
import { StepWrapper } from '../StepWrapper';

const deductionTypes = [
  {
    id: 'belgian_dividends',
    label: 'Belgische dividenden (vrijstelling eerste € 800)',
  },
  { id: 'french_dividends', label: 'Franse dividenden' },
  { id: 'other_foreign_dividends', label: 'Andere buitenlandse dividenden' },
  { id: 'other_income', label: 'Overige roerende inkomsten' },
  { id: 'life_insurance', label: 'Individuele levensverzekering' },
  { id: 'gifts', label: 'Giften' },
  { id: 'childcare', label: 'Kinderopvang' },
  { id: 'pension_savings', label: 'Pensioensparen' },
  { id: 'social_contributions', label: 'Sociale bijdragen (zelfstandigen)' },
  { id: 'vapz_pcz', label: 'VAPZ/PCZ' },
  { id: 'advance_payments', label: 'Voorafbetalingen' },
];

export default function Step() {
  return (
    <StepWrapper
      name="Belastingverminderingen"
      description="Zet een vinkje bij de belastingvermindering die van toepassing is voor aanvrager of partner."
      maxWidth={1000}
    >
      <Grid container spacing={2}>
        <Grid xs={12}>
          <TableContainer component={Paper} sx={{ mb: 3 }}>
            <Table size="small">
              <TableHead>
                <TableRow sx={{ backgroundColor: 'rgba(0, 0, 0, 0.02)' }}>
                  <TableCell sx={{ width: '60%' }}>Type</TableCell>
                  <TableCell align="center" sx={{ width: '20%' }}>
                    Aanvrager
                  </TableCell>
                  <TableCell align="center" sx={{ width: '20%' }}>
                    Partner
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {deductionTypes.map((type) => (
                  <TableRow
                    key={type.id}
                    sx={{
                      '&:last-child td, &:last-child th': { border: 0 },
                    }}
                  >
                    <TableCell component="th" scope="row" sx={{ py: 1 }}>
                      {type.label}
                    </TableCell>
                    <TableCell align="center" sx={{ py: 1 }}>
                      <CheckboxInput
                        name={`deductions.applicant.${type.id}`}
                        grid={false}
                        label={null}
                      />
                    </TableCell>
                    <TableCell align="center" sx={{ py: 1 }}>
                      <CheckboxInput
                        name={`deductions.partner.${type.id}`}
                        grid={false}
                        label={null}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <FilesField
            name="deductions_documents"
            title="Upload hier alle attesten (met betrekking tot deze verminderingen)"
            xs={12}
            md={12}
          />
        </Grid>
      </Grid>
    </StepWrapper>
  );
}
